<template>
    <div class="camper-maintenance-ad">
        <div class="camper-maintenance-ad__content">
            <h2 class="camper-maintenance-ad__heading">{{ translations.title }}</h2>
            <div>
                <img :src="image.source" :alt="image.alt" class="camper-maintenance-ad__img-mobile" />
                <p class="camper-maintenance-ad__description">
                    {{ translations.description }}
                </p>
            </div>
            <button class="button button--secondary-contrast" @click="displayCamperMaintenanceModal({ type })">
                {{ translations.button }}
            </button>
        </div>
        <img :src="image.source" :alt="image.alt" class="camper-maintenance-ad__img" />
    </div>
</template>

<script>
import modalMixin from '~/mixins/modalMixin';

const EXTENSION_PRICELIST = 'extension-pricelist';
const PURCHASE_CHECKLIST = 'purchase-checklist';
const WINTER_CHECKLIST = 'winter-checklist';
const PACKING_CHECKLIST = 'packing-checklist';

export default {
    name: 'CamperMaintenanceAd',
    mixins: [modalMixin],
    props: {
        type: {
            type: String,
            required: true,
            validator(value) {
                return [EXTENSION_PRICELIST, PURCHASE_CHECKLIST, WINTER_CHECKLIST, PACKING_CHECKLIST].includes(value);
            },
        },
    },
    computed: {
        translations() {
            const keys = {
                [EXTENSION_PRICELIST]: {
                    title: this.$t('camper_maintenance_ad.extension_pricelist.title'),
                    description: this.$t('camper_maintenance_ad.extension_pricelist.description'),
                    button: this.$t('camper_maintenance_ad.extension_pricelist.button'),
                },
                [PURCHASE_CHECKLIST]: {
                    title: this.$t('camper_maintenance_ad.purchase_checklist.title'),
                    description: this.$t('camper_maintenance_ad.purchase_checklist.description'),
                    button: this.$t('camper_maintenance_ad.purchase_checklist.button'),
                },
                [WINTER_CHECKLIST]: {
                    title: this.$t('camper_maintenance_ad.winter_checklist.title'),
                    description: this.$t('camper_maintenance_ad.winter_checklist.description'),
                    button: this.$t('camper_maintenance_ad.winter_checklist.button'),
                },
                [PACKING_CHECKLIST]: {
                    title: this.$t('camper_maintenance_ad.packing_checklist.title'),
                    description: this.$t('camper_maintenance_ad.packing_checklist.description'),
                    button: this.$t('camper_maintenance_ad.packing_checklist.button'),
                },
            };

            return keys[this.type] || keys[EXTENSION_PRICELIST];
        },
        image() {
            const images = {
                [EXTENSION_PRICELIST]: {
                    source: require('~/assets/images/camper-extension-pricelist.svg'),
                    alt: 'Extension pricelist',
                },
                [PURCHASE_CHECKLIST]: {
                    source: require('~/assets/images/camper-purchase-checklist.svg'),
                    alt: 'Purchase checklist',
                },
                [WINTER_CHECKLIST]: {
                    source: require('~/assets/images/camper-winter-checklist.svg'),
                    alt: 'Winter checklist',
                },
                [PACKING_CHECKLIST]: {
                    source: require('~/assets/images/camper-purchase-checklist.svg'),
                    alt: 'Packing checklist',
                },
            };

            return images[this.type] || images[EXTENSION_PRICELIST];
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/_variables.scss';

.camper-maintenance-ad {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
    background: $white;
    border-bottom: 1px solid $gray;

    @include md {
        padding: 32px 16px;
    }

    @include lg {
        justify-content: space-between;
    }

    &__heading {
        @extend %heading-2;
    }

    &__description {
        @include md {
            max-width: 660px;
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        gap: 32px;

        p {
            margin-bottom: 0;
        }

        @include md {
            gap: 24px;

            button {
                width: fit-content;
            }
        }
    }

    &__img-mobile {
        width: 33%;
        min-width: 100px;
        float: right;
        margin-top: -28px;
        margin-left: 6px;

        @include sm {
            width: 20%;
        }

        @include md {
            display: none;
        }
    }

    &__img {
        display: none;

        @include md {
            display: block;
            width: 20%;
            min-width: 150px;
            max-width: 250px;
            float: none;
            margin-left: 16px;
        }
    }
}
</style>
